import {fixedScroll} from "../../modules/disablescroll";

const $close = $('.c-popup__demo .close');

function openPopup(el, hashUrl, hashName) {
    if (hashUrl === hashName) {
        el.addClass('js-isActive');
        fixedScroll(true);
    }
}

if ($('.c-popup__demo').length > 0) {
    onhashchange = () => {
        const hash = window.location.hash;
        openPopup($(".c-popup__demo"), hash, '#demo');
    };

    if (window.location.href.indexOf("#demo") !== -1) {
        $(".c-popup__demo").addClass("js-isActive");
        fixedScroll(true);
    }

    $close.click(function () {
        $(".c-popup__demo").removeClass("js-isActive");
        parent.location.hash = '';
        fixedScroll(false);
    });
}
